/* app/ui/filter/filter */

define('app/ui/filter/filter',[
		'jquery',
		'util/core',
		'moment',
		'pikaday'
],
	function ($, Util, moment, Pikaday) {

		var Filter;

		var selectors = {
			filter: '.js-filter',
			form: '.js-filter__form',
			filterOption: '.js-filter__option',
			filterDate:'.js-filter__date',
			filterBtn: '.js-filter__btn',
			filterResetBtn: '.js-filter-refresh__btn',
			filterSearch:'.js-filter__keyword'
			//filterDelegate: '.js-filter__delegate'
		};

		function urlParam(name) {
			var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
			if (results === null) {
				return null;
			}
			else {
				return results[1] || 0;
			}
		}

		return {
			init: function() {
				Filter = this;
				Filter._initEvents();

				//DataPicker init
				var $DatePicker = $('.js-datepicker');
				if ($DatePicker.length) {
					$DatePicker.each(function() {
						var datepicker = new Pikaday(
							{
								field: $(this)[0],
								firstDay: 1,
								maxDate: new Date('31-12-2025'),
								yearRange: [2000, 2025],
								container: $(this).parent()[0],
								format: 'YYYY-MM-DD',
								onSelect: function() {
									var date = moment(datepicker.toString(), 'YYYY-MM-DD').format('YYYY-MM-DD');
									$(this).attr('data-date', date);
									$(this).val(moment(datepicker.toString(), 'YYYY-MM-DD').format('YYYY-MM-DD'));
								}
							});
					});
				}

				//auto collapse filter for mobile version 
				if ($(window).width() < 700) {
					var $filterToggle = $(selectors.filter).find('.js-expand-collapse__header');
					if ($filterToggle.length) {
						setTimeout(function() {
								$filterToggle.trigger('click');
							},
							2000);
					}
				}
			},

			_initEvents: function() {

				$(document).on('click', selectors.filterBtn, Filter._processFilterClick);
				$(document).on('click', selectors.filterResetBtn, Filter._processResetClick);

				//tricky function to add the 'overflow' proper after the animation finish
				$(document).on('click', '.js-expand-collapse__header', Filter._ExpandOverflowProcess);
			},

			_processFilterClick: function(e) {
				e.preventDefault();
				var $form = $(e.target).closest(selectors.form);
				Filter._applyFilter($form);
			},
			_processResetClick: function(e) {
				e.preventDefault();
				//todo query reset
				var term = urlParam('term');
				var url = document.location.origin + document.location.pathname;
				if (term) {
					url = url + "?term=" + term;
				}
				window.location.href = url + '#active-top';
			},


			_applyFilter: function($form) {
				var queryString = Filter._buildQueryStringFromForm($form),
					url = document.location.origin +
						document.location.pathname +
						(queryString ? '?' + queryString : '');
				//console.log(url);
				window.location.href = url + '#active-top';
			},

			_buildQueryStringFromForm: function($form) {
				var query = Util.getQueryStringObject($form.serialize());
				var queryString = '';
				var term = urlParam('term');
				var $dateFilters = $(selectors.filterDate);
				var $keywordFilter = $(selectors.filterSearch);
				for (var i in query) {
					queryString += '&' + i + '=' + query[i];
				}
				queryString = queryString.substr(1);

				if ($dateFilters.length) {
					var $fromDate = $dateFilters.find('#from-datepicker');
					var $toDate = $dateFilters.find('#to-datepicker');
					if ($fromDate.val()) {
						queryString = queryString + '&from-date=' + $fromDate.val();
					}
					if ($toDate.val()) {
						queryString = queryString + '&to-date=' + $toDate.val();
					}
				}

				if ($keywordFilter.length) {
					var keyword = $keywordFilter.val();
					queryString = queryString + '&term=' + keyword;
				} else if (term) {
					queryString = queryString + '&term=' + term;
				}


				return queryString;
			},

			_ExpandOverflowProcess: function(event) {
				var $target = $(event.target);
				var $item = $target.closest('.js-expand-collapse__item');
				if ($item.length) {
					if ($item.hasClass('is-expanded')) {
						setTimeout(function() {
								$item.addClass('no-overflow');
							},
							1000);
					} else {
						$item.removeClass('no-overflow');
					}
				}

			}


		};
	});
